import React from "react";
// import "../App.css";
import "../Footer.css";

export default function Footer() {
	return (
		<div className="footer-container">
			<p> Made by the foodies from Lambda School © Secret Family Recipes 2020</p>
			<p> Build Week </p>
		</div>
	);
}
